import "./index.css";
import "babel-polyfill";
import "react-app-polyfill/ie11";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter basename={"/live"}>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
